import { Skeleton } from '@mui/material';
import React from 'react';

const DefaultLoader: React.FC = () => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '16px', padding: '20px', minHeight: '100vh'}}>
      <Skeleton variant="rectangular" sx={{ fontSize: '1rem', width: '100%', height: '60px'}}/>
      <Skeleton variant="rectangular" sx={{ fontSize: '1rem', width: '100%', height: '60px'}}/>
      <Skeleton variant="rectangular" sx={{ fontSize: '1rem', width: '100%', height: '60px'}}/>
      <Skeleton variant="rectangular" sx={{ fontSize: '1rem', width: '100%', height: '60px'}}/>
      <Skeleton variant="rectangular" sx={{ fontSize: '1rem', width: '100%', height: '60px'}}/>
    </div>
  );
};

export default DefaultLoader;